export default __webpack_public_path__ + "../staticImages/winzer-260.png";